import { useEffect, useState } from "react";
import api from "../services/api";

// O modelo da ficha muda raramente: guarda em memória por alguns minutos
// para não buscar de novo a cada atendimento aberto.
const TTL_MS = 5 * 60 * 1000;
let cache = null; // { at, promise }

export const loadContactFieldTemplates = () => {
  if (!cache || Date.now() - cache.at > TTL_MS) {
    const promise = api
      .get("/contact-field-templates")
      .then(({ data }) => data || [])
      .catch(() => {
        cache = null; // tenta de novo na próxima vez
        return [];
      });
    cache = { at: Date.now(), promise };
  }
  return cache.promise;
};

// chamado depois de salvar o modelo na tela de configurações
export const setContactFieldTemplatesCache = (fields) => {
  cache = { at: Date.now(), promise: Promise.resolve(fields || []) };
};

const useContactFieldTemplates = () => {
  const [templates, setTemplates] = useState([]);

  useEffect(() => {
    let active = true;
    loadContactFieldTemplates().then((data) => {
      if (active) setTemplates(data);
    });
    return () => {
      active = false;
    };
  }, []);

  return templates;
};

export default useContactFieldTemplates;
